import {Injectable, signal} from '@angular/core';
import {LucideIconData} from 'lucide-angular';

export interface Notification {
  message: string;
  title?: string;
  icon?: LucideIconData;
  dismissable?: boolean;
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private static readonly NOTIFICATION_DURATION = 10_000;

  private readonly _notifications = signal<Notification[]>([]);
  public readonly notifications = this._notifications.asReadonly();

  public toast(notification: Notification): void {
    if (notification.dismissable === undefined) {
      notification.dismissable = true;
    }
    if (notification.duration === undefined) {
      notification.duration = NotificationService.NOTIFICATION_DURATION;
    }
    this._notifications.update(n => [...n, notification]);
    if (notification.duration) {
      setTimeout(() => {
        this.remove(notification);
      }, notification.duration);
    }
  }

  public remove(notification: Notification): void {
    this._notifications.update(n => n.filter(n => n !== notification));
  }

}
